module.exports = __webpack_public_path__ + "img/sld_up_arrow.d4b8bd7d.svg";